export default __webpack_public_path__ + "static/media/visaPay@3x.621ec769.png";